export const ftToCm = (val) => {
     if (val === null || val === undefined || val < 0 || val === '') {
        return null
    }
    return (val * 30.48).toFixed(5)
}

export const cmToFt = (val) => {
    if (val === null || val === undefined || val < 0 || val === '') {
        return null
    }
    return (val / 30.48).toFixed(5)
}

export const packagesFttoCm = (pkgs = []) => {
    if (pkgs === null || pkgs === undefined || pkgs.length < 1) {
        return []
    }
    let updatedPkgs = pkgs.map((item, index) => {
        let length, width, height, vWt;
        length = ftToCm(item.packageLength);
        width = ftToCm(item.packageWidth);
        height = ftToCm(item.packageHeight);
        vWt = Number(item.vWeight).toFixed(5)
        return {
            ...item,
            packageLength: length,
            packageHeight: height,
            packageWidth: width,
            vWeight: vWt
        }
    }
    )
    return updatedPkgs
}

export const packagesCmtoFt = (pkgs = []) => {
    if (pkgs === null || pkgs === undefined || pkgs.length < 1) {
        return []
    }
    let updatedPkgs = pkgs.map((item, index) => {
        let length, width, height, vWt;
        length = cmToFt(item.packageLength);
        width = cmToFt(item.packageWidth);
        height = cmToFt(item.packageHeight);
        vWt = Number(item.vWeight).toFixed(5)
        return {
            ...item,
            packageLength: length,
            packageHeight: height,
            packageWidth: width,
            vWeight: vWt
        }
    }
    )
    return updatedPkgs
}

export const mapGrabOrderNotification = (notification) => {
  const product = notification.product_id;
  const order = notification.order;
  const productImage =
    product?.images?.find(img => img.baseImage)?.image ||
    product?.images?.[0]?.image ||
    '';

  const combination = product?.combination?.[0] || null;

  return {
    title: 'New Grab Order',
    body: `There is an order for ${notification.productName}. This is your chance to fulfil the order!`,
    type: 'GRAB_ORDER',

    expTransferPriceFrom: `${notification.expTransferPriceFrom}`,
    expTransferPriceTo: `${notification.expTransferPriceTo}`,

    productName: notification.productName,
    SKU: product?.SKU || '',
    orderId: order?.orderId || '',
    _id: product?._id || '',
    quantity: `${order?.products?.[0]?.quantity || 0}`,

    urlKey: combination?.url || product?.urlKey || '',

    attributes:
      product?.combination && product.combination.length
        ? JSON.stringify(product.combination[0]?.value || {})
        : '',

    attributeValue: combination
      ? JSON.stringify(combination.value || {})
      : '',

    image: productImage,
    path: '/my-order/graborder'
  };
};
